require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/node_modules/core-js/library/fn/object/set-prototype-of.js